module.exports = __webpack_public_path__ + "img/money-bg.1bb04e60.png";